import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as i18next from 'i18next';
import moment from 'moment';
import * as api from 'core/api';
import * as auth from 'core/auth';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export default class AccountCouponsComponent extends Vue {
    $auth: auth.AuthService; // Injected in G2S.init

    @Prop()
    user: api.UserAccount;

    coupons: api.CouponListModel[] = [];

    couponsPageSize: number = 3;
    couponsVisible: number = this.couponsPageSize;

    get pagedCoupons(): api.CouponListModel[] {
        return this.coupons.slice(0, this.couponsVisible);
    }

    mounted() {
        this.loadModel();
    }

    loadModel() {
        this.coupons = [];

        new api.CouponService().listAvailable().then(
            (result: api.CouponListModel[]) => {
                if (result && result.length > 0) {
                    this.coupons = result;
                }
            },
            (error) => {
                if (error.response) {
                    console.log('XHR failed', error.response.status, error.response.data);
                } else {
                    console.log('XHR error', error.message);
                }
            }
        );
    }

    getExpiresLabel(coupon: api.CouponListModel): string {
        return i18next.t('label_coupon_expires',
            <any>{ i: moment(coupon.expiryDate).format(i18next.t('format_date_md')) }
        );
    }

    getCouponUseUrl(coupon: api.CouponListModel): string {
        return '/go/coupon/' + coupon.name;
    }

    onShowAll() {
        if (this.couponsVisible < this.coupons.length) {
            this.couponsVisible = this.coupons.length;
        } else {
            this.couponsVisible = this.couponsPageSize;
        }
    }
}
